import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import {Menu, MenuItem, Paper} from 'material-ui'
import onClickOutside from 'react-onclickoutside'

class NavMenu extends React.Component {

	constructor(props) {
		super(props)

		this.state = { menuDisplayed: false }
	}

	showNavMenu(show) {
		this.props.displayHandler(show)
		this.state.menuDisplayed = show
	}

	handleClickOutside(evt) {
		this.showNavMenu(false)
	}

	handleMenuClick(evt) {
		if (!this.state.menuDisplayed) {
			this.showNavMenu(true)
		} else {
			this.showNavMenu(false)
		}
	}

	handleSubmenuItemClick(value, evt) {
		evt.stopPropagation()

		this.showNavMenu(false)

		let redirectLinks = this.props.redirectLinks
		let redirectLink = redirectLinks[_.camelCase(value)]

		redirectLink()
	}

	renderNavSubmenu() {
		let { submenu } = this.props

		return _.map(submenu, (value, key) => {
			return (
			<MenuItem key={key} style={{color: '#757575', letterSpacing: '0.08rem', fontFamily: 'Poppins'}} onTouchTap={this.handleSubmenuItemClick.bind(this, value)}>{value}</MenuItem>
			)
		})
	}

	renderNavMenu() {
    let { display, menuTitle } = this.props;

    return (
      <div>
        <Paper style={{
              'position': 'absolute', 
              'top': '50px', right: '10px',
              'display': display ? 'block' : 'none',
              'text-align': 'left'
            }}>
          <Menu
            openDirection={'top-left'}
            autoWidth={false}>
            {this.renderNavSubmenu()}
          </Menu>
        </Paper>
      </div>
    )
  }

	render() {
		let { navElement, menuTitle } = this.props
		return (
		<div className=''
		onTouchTap={this.handleMenuClick.bind(this)}>
			<div className='flex justify-around items-center'>
				<div>{navElement}</div>
				<div className='menu-text pl1'>{menuTitle && menuTitle}</div>
			</div>
			{this.renderNavMenu()}
		</div>
		)
	}
}

NavMenu.propTypes = {
	display: PropTypes.bool.isRequired,
	displayHandler: PropTypes.func.isRequired,
	redirectLinks: PropTypes.object.isRequired,
	navElement: PropTypes.element.isRequired,
	menuTitle: PropTypes.string.isRequired,
	submenu: PropTypes.object.isRequired
}

export default onClickOutside(NavMenu)


// WEBPACK FOOTER //
// ./src/app/views/NavMenu.js